import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {SearchService} from '../../../services/search.service';

@Component({
  selector: 'my-branch',
  templateUrl: './my-branch.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class MyBranchComponent implements OnInit, OnDestroy {
  public loading = true;
  public failed = false;
  public listings = [];
  private destroyed = false;

  constructor(private search: SearchService, private router: Router) {}

  async ngOnInit() {
    await this.loadEvents();
  }

  async loadEvents() {
    this.loading = true;
    this.failed = false;
    try {
      const listings = await this.search.getMyBranchEvents();
      if (this.destroyed) {
        return;
      }
      this.listings = listings;
      if (listings.length === 1) {
        const listing = listings[0];
        await this.router.navigate(['/listing', listing.id, listing.slug], {
          replaceUrl: true,
        });
      }
    } catch (error) {
      this.failed = true;
    } finally {
      this.loading = false;
    }
  }

  ngOnDestroy() {
    this.destroyed = true;
  }
}
